/* Controllers */
import MaintenanceHistoryController from './history.controller';
import MaintenanceHistoryDetailsController from './details/details.controller';

const historyModule = angular.module('app.maintenance.history', [
	'ui.bootstrap',
	'ui.router',
	'gettext'
]);

historyModule
// Controllers of the history module
.controller('MaintenanceHistoryController', MaintenanceHistoryController)
.controller('MaintenanceHistoryDetailsController', MaintenanceHistoryDetailsController);

export default historyModule.name;
